import styled from 'styled-components';
import { fontBody } from 'Styles/fonts';

import Button from '../Button/Button';

export const CTA = styled(Button).attrs({
  variant: 'secondary',
  isGhost: true
})`
  ${fontBody(16)};
  color: var(--foreground);
  cursor: pointer;
  text-decoration: underline;
  padding: 0;
  min-height: auto;
`;

export default {};
